import React, { Component } from 'react';
import './Settings.css';
import { getCategory } from '../helpers/triviaAPI';
import { difficulty } from '../helpers/helpers';

export default class Settings extends Component {
  // state = {
  //   triviaCategories: [],
  //   number: '',
  //   category: '',
  //   difficulty: '',
  //   type: '',
  // };

  async componentDidMount() {
    const category = await getCategory();
    console.log(category);
    this.setState({
      triviaCategories: category,
    });
  }

  onInputChange = ({ target: { name, value } }) => {
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { triviaCategories, category } = this.state;
    return (
      <div>
        <form action="">
          <h1
            data-testid="settings-title"
            className="settings-container"
          >
            Configurações
          </h1>
          <label htmlFor="">
            Numero de Questões:
            <input
              name="number"
              max={ 20 }
              type="number"
              onInput={ this.onInputChange }
            />
          </label>
          <select
            name="category"
            onInput={ this.onInputChange }
            value={ category }
          >
            {
              triviaCategories.map(({ name, id }) => (
                <option
                  key={ name }
                  value={ id }
                >
                  { name }
                </option>
              ))
            }
          </select>
          <select
            name="category"
            onInput={ this.onInputChange }
            value={ category }
          >
            {
              difficulty.map((dif) => (
                <option
                  key={ dif }
                  value={ dif }
                  name="difficulty"
                >
                  { dif }
                </option>
              ))
            }
          </select>
          <select>
            <option name="type" value="multiple">
              Multiple Choice
            </option>
            <option value="boolean">
              True or False
            </option>

          </select>
        </form>

      </div>
    );
  }
}
// api geral
// https://opentdb.com/api.php?amount=${10}&category=${20}&difficulty=${medium}&type=${multiple}

// usa a id da categoria para filtrar api
// https://opentdb.com/api_count.php?category=CATEGORY_ID_HERE
